import { z } from 'zod'

/**
 * Individual TLD item from the catalog
 * Used by GET /domain/tlds and GET /domain/featured
 */
export const TLDCatalogItem = z.object({
  tld: z.string(),
  price: z.number(), // Renewal price in cents
  register_price: z.number().optional(), // Registration price in cents
  transfer_price: z.number().optional(), // Transfer price in cents
  promo: z.boolean().optional(),
  promo_register_price: z.number().optional(), // Promotional registration price in cents (when promo is true)
  category: z.enum(['generic', 'cctld', 'new_gtld', 'other']).optional()
})

export type TLDCatalogItem = z.infer<typeof TLDCatalogItem>

/**
 * Response from GET /domain/tlds
 */
export const TLDCatalogResponse = z.object({
  tlds: z.array(TLDCatalogItem),
  updated_at: z.number().optional(),
  total_count: z.number().optional()
})

export type TLDCatalogResponse = z.infer<typeof TLDCatalogResponse>
